import { Link, useSearchParams } from "react-router";
import { useAuth } from "@client/app/auth";
import { Card, PageHeader, Spinner } from "@client/components/ui";
import { useT } from "@client/i18n";
import { authLink } from "@client/lib/returnTo";

export function CourseStartPage() {
  const t = useT();
  const { user, isLoading } = useAuth();
  const [params] = useSearchParams();
  const course = params.get("course") ?? "HT2026";
  const lecture = params.get("lecture");
  const invalid =
    course !== "HT2026" ||
    (lecture !== null && !/^(F(0[1-9]|1[0-2])|R0[1-3])$/.test(lecture)) ||
    ["course", "lecture"].some((key) => params.getAll(key).length > 1);
  const target = lecture ? `/practice?${new URLSearchParams({ course, lecture })}` : null;
  const linkStyle =
    "inline-flex min-h-11 items-center rounded-lg border border-accent-600 px-4 py-2 font-medium text-accent-800 focus-visible:outline focus-visible:outline-2 dark:text-accent-200";
  return (
    <main className="mx-auto max-w-2xl px-4 py-10 text-ink-800 dark:text-ink-100">
      {invalid ? (
        <>
          <p role="alert">{t("courseStart.notFound")}</p>
          <Link to="/start?course=HT2026" className="underline">
            {t("courseStart.title")}
          </Link>
        </>
      ) : (
        <>
          <PageHeader title={t("courseStart.title")} description={t("courseStart.book")} />
          <Card>
            <div className="space-y-4">
              <p>{t("courseStart.accounts")}</p>
              <p>{t("courseStart.registration")}</p>
              <p>{t("auth.registrationGuidance")}</p>
              <div className="flex flex-wrap gap-3">
                {isLoading ? (
                  <Spinner label={t("common.loading")} />
                ) : user ? (
                  <Link className={linkStyle} to={target ?? "/home"}>
                    {lecture ? t("courseStart.continue", { lecture }) : t("nav.home")}
                  </Link>
                ) : (
                  <>
                    <Link className={linkStyle} to={target ? authLink("login", target) : "/login"}>
                      {t("auth.signIn")}
                    </Link>
                    <Link
                      className={linkStyle}
                      to={target ? authLink("register", target) : "/register"}
                    >
                      {t("auth.signUp")}
                    </Link>
                  </>
                )}
              </div>
              {lecture && (
                <>
                  <p>{t("courseStart.selection", { lecture })}</p>
                  <Link className={linkStyle} to={target ?? "/home"}>
                    {t("courseStart.open")}
                  </Link>
                </>
              )}
            </div>
          </Card>
          <section className="mt-8 space-y-3">
            <h2 className="font-display text-xl">{t("auth.privacyTitle")}</h2>
            <p>{t("auth.privacyBody")}</p>
            <p>{t("courseStart.reporting")}</p>
            <p>{t("courseStart.delete")}</p>
          </section>
          <section className="mt-8 space-y-3">
            <h2 className="font-display text-xl">{t("courseStart.studyTitle")}</h2>
            <p>{t("courseStart.study")}</p>
          </section>
        </>
      )}
    </main>
  );
}
